import React, { useState, useContext } from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import { Accordion } from 'react-bootstrap';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import AccordionContext from 'react-bootstrap/AccordionContext';
import SectionTitle from './sectionTitle/SectionTitle';

const pricingPlan = {
    rightColumn: [
        {
            id: 1,
            title: 'CEMEFI',
            body: ''

        },
        {
            id: 2,
            title: 'CONFÍO',
            body: 'contenido 2'
        },
        {
            id: 3,
            title: 'SAT',
            body: 'contenido 3'
        }
    ]
}

const CustomToggle = ({ children, eventKey }) => {
    const { activeEventKey } = useContext(AccordionContext);
    const decoratedOnClick = useAccordionButton(eventKey);
    const isCurrentEventKey = activeEventKey === eventKey;
    return <button type="button" onClick={decoratedOnClick} aria-expanded={isCurrentEventKey ? true : false} className="edu-accordion-button">{children}</button>
}

const ContenidoPoliticaDePrivacidad = ({ wrapperclassName }) => {

    const [selectedItem, setSelectedItem] = useState('online-education');
    const [activeId1, setActiveId1] = useState('0');
    const [activeId2, setActiveId2] = useState('0');
    const [activeId3, setActiveId3] = useState('0');
    const [activeId4, setActiveId4] = useState('0');
    const [activeId5, setActiveId5] = useState('0');
    const [activeId6, setActiveId6] = useState('0');

    function toggleActive1(id) {
        if (activeId1 === id) {
            setActiveId1(null);
        } else {
            setActiveId1(id);
        }
    }
    function toggleActive2(id) {
        if (activeId2 === id) {
            setActiveId2(null);
        } else {
            setActiveId2(id);
        }
    }
    function toggleActive3(id) {
        if (activeId3 === id) {
            setActiveId3(null);
        } else {
            setActiveId3(id);
        }
    }
    function toggleActive4(id) {
        if (activeId4 === id) {
            setActiveId4(null);
        } else {
            setActiveId4(id);
        }
    }
    function toggleActive5(id) {
        if (activeId5 === id) {
            setActiveId5(null);
        } else {
            setActiveId5(id);
        }
    }
    function toggleActive6(id) {
        if (activeId6 === id) {
            setActiveId6(null);
        } else {
            setActiveId6(id);
        }
    }

    return (

        <div className="container-conocenos">
            <div className="row">

                <div className="col-lg-12">
                    <div className={`edu-accordion-area accordion-shape-1 edu-section-gap bg-color-white ${wrapperclassName ? wrapperclassName : ''} `}>
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <p className='has-dark-color'>
                                        <strong>Caracol Centro Científico y Cultural, A.C.</strong>
                                        <br />
                                        Última actualización: [04/02/2026]


                                        <br /> <br />
                                        <strong>I. Responsable del tratamiento de datos personales</strong>
                                        <br />
                                        Caracol Centro Científico y Cultural, A.C., con domicilio en Ensenada, Baja California, México, es responsable del tratamiento de los datos personales que recaba de conformidad con la legislación aplicable en materia de protección de datos personales.
                                        <br /> <br />
                                        <strong>II. Datos personales que recabamos</strong>
                                        <br />
                                        Dependiendo de la relación que usted tenga con la institución, podremos recabar las siguientes categorías de datos:
                                        <br />
                                        <strong>1. Datos de identificación</strong>
                                        &emsp;● Nombre completo
                                        <br />
                                        &emsp;● Domicilio
                                        <br />
                                        &emsp;● Teléfono
                                        <br />
                                        &emsp;● Correo electrónico
                                        <br />
                                        &emsp;● Firma
                                        <br />
                                        &emsp;●  RFC (en caso de facturación)
                                        <br />
                                        <strong>  2. Datos laborales o profesionales</strong>
                                        <br />
                                        &emsp;● Cargo
                                        <br />
                                        &emsp;● Institución u organización de procedencia
                                        <br />
                                        <strong> 3. Datos financieros (en caso de donaciones o pagos)</strong>
                                        <br />
                                        &emsp;● Datos de facturación
                                        <br />
                                        &emsp;● Información bancaria cuando aplique
                                        <br />

                                        <br />

 


                                        <strong>  4. Datos académicos (en actividades educativas específicas)</strong>
                                        <br />


                                        Caracol no recaba datos personales sensibles salvo que resulte estrictamente necesario y con el consentimiento expreso del titular.
                                        <br /> <br />
                                        <strong>III. Finalidades del tratamiento</strong>
                                        <br />
                                        Los datos personales serán utilizados para las siguientes finalidades primarias:
                                        <br />
                                        &emsp;● Registro y control de acceso a actividades, talleres y eventos
                                        <br />
                                        &emsp;● Gestión administrativa de asociados
                                        <br />
                                        &emsp;● Facturación y cumplimiento de obligaciones fiscales
                                        <br />
                                        &emsp;● Gestión de donativos y emisión de recibos deducibles
                                        <br />
                                        &emsp;● Comunicación institucional
                                        <br />
                                        &emsp;● Atención a proveedores y convenios
                                        <br />
                                        &emsp;● Procesos de reclutamiento y administración de personal
                                        <br />
                                        <strong>Finalidades secundarias:</strong>
                                        <br />
                                        &emsp;● Envío de boletines informativos
                                        <br />
                                        &emsp;● Invitaciones a eventos
                                        <br />
                                        &emsp;● Encuestas de satisfacción
                                        <br />
                                        &emsp;● Información sobre campañas y programas
                                        <br />
                                        Si no desea que sus datos sean utilizados para finalidades secundarias, puede manifestarlo al correo indicado en este aviso.
                                        <br /> <br />
                                        <strong>IV. Transferencia de datos</strong>
                                        <br />
                                        Caracol podrá transferir datos personales:
                                        <br />
                                        &emsp;● A autoridades fiscales y administrativas cuando sea requerido por ley
                                        <br />
                                        &emsp;● A instituciones con las que exista convenio formal
                                        <br />
                                        &emsp;● A proveedores de servicios tecnológicos necesarios para la operación (por ejemplo, plataformas de gestión o correo electrónico), bajo contratos que garanticen confidencialidad
                                        <br />
                                        No se comercializan ni venden datos personales.
                                        <br /> <br />
                                        <strong>V. Derechos ARCO</strong>
                                        <br />
                                        Usted tiene derecho a:
                                        <br />
                                        &emsp;● Acceder a sus datos personales
                                        <br />
                                        &emsp;● Rectificarlos si son inexactos
                                        <br />
                                        &emsp;● Cancelarlos cuando considere que no se requieren
                                        <br />
                                        &emsp;● Oponerse a su tratamiento
                                        <br />
                                        Para ejercer sus derechos ARCO, deberá enviar solicitud al correo: datos.personales@caracolbc.org
                                        <br />
                                        La solicitud deberá contener:
                                        <br />
                                        &emsp;● Nombre del titular
                                        <br />
                                        &emsp;● Descripción clara del derecho que desea ejercer
                                        <br />
                                        &emsp;● Documentación que acredite identidad
                                        <br />
                                        Caracol dará respuesta en los plazos establecidos por la ley.
                                        <br /> <br />
                                        <strong>VI. Revocación del consentimiento</strong>
                                        <br />
                                        Usted puede revocar el consentimiento que haya otorgado para el tratamiento de sus datos enviando solicitud al mismo correo indicado anteriormente.
                                        <br /> <br />
                                        <strong>VII. Uso de tecnologías de rastreo</strong>
                                        <br />
                                        El sitio web de Caracol puede utilizar cookies u otras tecnologías de seguimiento para mejorar la experiencia del usuario y obtener estadísticas de navegación.
                                        <br />
                                        Usted puede deshabilitar el uso de cookies desde la configuración de su navegador.
                                        <br /> <br />
                                        <strong>VIII. Cambios al aviso de privacidad</strong>
                                        <br />
                                        Cualquier modificación al presente Aviso de Privacidad será publicada en el sitio web oficial de la institución.


                                        
                                    </p>
                                </div>
                            </div>


                        </div>
                    </div>

                </div>
            </div>
            <div className="container-fluid px-lg-5 py-5 text-section">
                <div className="row">
                    <div className="col-lg-6">

                    </div>
                    <div className="col-lg-6">


                    </div>
                </div>
            </div>

        </div>




    )
}

export default ContenidoPoliticaDePrivacidad;


